import { TbThumbDown } from 'react-icons/tb'

import { dictionaryCodeFormTemplate } from '../Components/DictionaryCodeHint'
import { TopMenu } from '../Components/TopMenu'
import { DICTIONARY_SEARCH_FIELDS } from '../Contracts/DictionaryFields'
import { LOSS_REASON_LIST_COLUMNS, LOSS_REASON_LIST_FILTERS, lossReasonListFields } from '../Contracts/LossReasonListFields'
import { CheckDictionaryPageAccessTask } from '../Tasks/CheckDictionaryPageAccessTask'

import type { IResourceConfig } from '@/Core/Contracts/UI'

/**
 * Довідник «Причини програшу тендерів» (сім'я `LossReasonList`, `SPEC-007` §4).
 *
 * Чому тендер програно (етап 2).
 *
 * Сторінку бачить лише той, кому бек дає створення довідників, тобто
 * адміністратор (`pageConfig.accessFn`, `SPEC-007` §7.1); читати довідник для
 * селектів може кожен.
 */
export const ListTenderLossReasonResource: IResourceConfig = {
    title: 'Причини програшу тендерів',
    fields: lossReasonListFields(),
    table: {
        showColumns: LOSS_REASON_LIST_COLUMNS,
    },
    filter: {
        includeFields: LOSS_REASON_LIST_FILTERS,
    },
    // Підказка про код — у формі, над полем «Код» (`SPEC-007` §12)
    form: {
        template: dictionaryCodeFormTemplate,
    },
    places: {
        top: <TopMenu current="tender-loss-reasons" />,
    },
    restUrl: '/services/tender_loss_reasons',
    pageUrl: '/settings/tender-loss-reasons',
    pageConfig: {
        title: 'Причини програшу тендерів',
        icon: <TbThumbDown />,
        accessFn: CheckDictionaryPageAccessTask,
    },
    settings: {
        searchFields: DICTIONARY_SEARCH_FIELDS,
    },
}
